/* eslint-disable */

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React, { Component } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';

import { Button } from 'semantic-ui-react';
import {
  IMessage,
  FBMessenger,
  FBMessengerUrl,
  InstagramDM,
  InstagramUrlDM,
  Whatsapp
} from '../share';

const Container = styled.div`
  margin-bottom: 20px;
  overflow: hidden;
  max-width: 100%;
`;
const Original = styled.div`
  float: left;
`;
const Media = styled.div`
  margin-right: 100px !important;
`;
const MediaContent = styled.a`
  float: left;
  width: 250px;
  position: relative;
  border-radius: 3px;
  background-color: #fff;
  margin: 5px 0;
  border: 1px solid #969696;
`;
const Image = styled.img`
  max-width: 248px;
  -webkit-border-top-left-radius: 3px;
  -webkit-border-top-right-radius: 3px;
  -moz-border-radius-topleft: 3px;
  -moz-border-radius-topright: 3px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`;
const Link = styled.p`
  color: #aaa;
  font-size: 12px;
  margin: 0;
  text-align: left;
`;
const Description = styled.p`
  color: #111;
  font-size: 14px;
  margin: 0 0 3px 0;
  text-align: left;
  word-wrap: break-word;
`;
const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 15px;
`;
const Previews = styled.div`
  float: left;
  width: 62.5%;
  margin-left: 25px;
  max-width: 900px;
`;
const LogosContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;
const LogoLink = styled.a`
  margin: 0 5px;
  cursor: pointer;
  opacity: ${({ children }) => {
    const { props } = children;
    return props.type === props.currentType ? '1' : '0.25';
  }};
`;
const Logo = styled.img`
  height: 24px;
`;

class MediaInstagramComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    };
  }

  toggleShow = () => {
    // localStorage.setItem('Shared', !this.state.show);
    this.setState({ show: !this.state.show });
  };

  subStr = (text, limit) => {
    const maxLenght = !limit ? 100 : limit;
    return text.length > maxLenght
      ? `${text.substring(0, maxLenght)}...`
      : text;
  };

  render() {
    const { item, type, onChangeType } = this.props;
    const media = item;
    const description =
      media.caption && media.caption.text ? media.caption.text : '';
    const descIMessage =
      description.length > 0
        ? `${media.user.full_name} en Instagram:\n"${description}"`
        : '';
    const descWhatsapp =
      description.length > 0
        ? `${media.user.full_name} en Instagram:\n"${description}"`
        : '';
    const descFBUrl =
      description.length > 0 ? `${media.user.full_name} en Instagram:` : '';
    const metaWhatsapp = `${media.likes.count} Me gusta, ${media.comments.count} comentarios - ${media.user.full_name} (@${media.user.username}) en Instagram:`;

    const image = media.images.standard_resolution.url;

    const settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (
      <Container>
        <Original>
          <Media className="preview-container">
            <MediaContent>
              <Image src={image} alt={this.subStr(description)} />
              <div className="media-data">
                <Description>{this.subStr(description)}</Description>
                <Link>instagram.com</Link>
              </div>
            </MediaContent>
            <ButtonContainer>
              <Button onClick={() => this.toggleShow()} fluid secondary>
                Test Share
              </Button>
            </ButtonContainer>
          </Media>
        </Original>

        {this.state.show && (
          <Previews className="previews-slider">
            <Slider {...settings}>
              <IMessage
                image={image}
                source={`instagram.com`}
                description={descIMessage}
                link={media.link}
                subStr={this.subStr}
              />
              <FBMessenger
                image={image}
                source={`instagram.com`}
                link={media.link}
                subStr={this.subStr}
              />
              <FBMessengerUrl
                title={descFBUrl}
                description={description}
                image={image}
                source={`instagram.com`}
                link={media.link}
                subStr={this.subStr}
              />
              <InstagramDM
                image={image}
                author={media.user.username}
                authorImage={media.user.profile_picture}
                description={description}
                link={media.link}
                subStr={this.subStr}
              />
              <InstagramUrlDM
                image={image}
                author=""
                authorImage=""
                description={description}
                link={media.link}
                subStr={this.subStr}
              />
              <Whatsapp
                image={image}
                shortDescription={`"${description}"`}
                description={descWhatsapp}
                metadata={metaWhatsapp}
                link={media.link}
                source={`www.instagram.com`}
                subStr={this.subStr}
              />
            </Slider>
          </Previews>
        )}
        <div className="clearfix" />
      </Container>
    );
  }
}

export default MediaInstagramComponent;



// WEBPACK FOOTER //
// ./src/components/share/MediaInstagram.js